import { render, staticRenderFns } from "./pr-logs.vue?vue&type=template&id=146df36f&"
import script from "./pr-logs.vue?vue&type=script&lang=js&"
export * from "./pr-logs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports